<template>
    <div>
        <label class="fileContainer w3-blue w3-button">
            {{title}}
            <input type="file" @change="loadTextFromFile">
        </label>
    </div>   
</template>

<script>
export default {
  name: "FileReader",
  props: {
    title: ''
  },
  methods: {
    loadTextFromFile(ev) {
      try {
        const file = ev.target.files[0];
        const reader = new FileReader();
        reader.onload = e => {
            this.$emit("load", e.target.result);
        }
        reader.readAsText(file);
      } catch(e){
          console.log(e);
      }
    }
  },
  created: function(){ 
  }
};
</script>

<style>
.fileContainer {
    overflow: hidden;
    position: relative;
}

.fileContainer [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}


</style>